import classNames from "classnames";
import React from "react";
import style from "../../scss/export.module.scss";
import { CloseButton } from "../CloseButton";
import "./pill.scss";

type TPill = {
    text: string;
    onRemove?: () => void;
    bgColor?: string;
    textColor?: string;
    iconColor?: string;
    disabled?: boolean;
};

export const Pill = ({ text, onRemove, bgColor, textColor, iconColor, disabled }: TPill) => {
    return (
        <div
            className={classNames("c-pill", { "c-pill--disabled": disabled })}
            style={bgColor ? { backgroundColor: bgColor } : undefined}
        >
            <div className="c-pill__text" style={bgColor ? { color: textColor } : undefined}>
                {text}
            </div>
            <CloseButton
                onClick={() => !disabled && onRemove?.()}
                icon="close-circle"
                iconSize={18}
                iconColor={iconColor ?? style.brandBlueColor}
                disabled={disabled}
            />
        </div>
    );
};

export default Pill;
